import React from 'react'

type Props = {
    className?      : string

    options?        : Option[]
    selectedValue   : any

    onChange?       : callback
}

export default function RadioGroupStateless(props:Props){

    const onSelectOption = (value:any) => {
        props.onChange?.(value)
    }

    return (
        <div className={props.className}>
            {_.map(props.options, (option:Option, key:number)=>{
                const radioClasses = Classes("ui5-radio s-13 m-r-10", {
                    selected: props.selectedValue === option.value
                })

                const labelClasses = Classes("ui5-txt-default", {
                    'ui5-txt-semi-bold': props.selectedValue === option.value
                })

                return (
                    <div key={key} className="flex-column-left-top m-b-15" onClick={onSelectOption.bind(null, option.value)}>
                        <div className="flex-row-left-center">
                            <div className={radioClasses}/>
                            <div className={labelClasses}>
                                {option.label}
                            </div>
                        </div>

                        {option.description &&
                            <div className="ui5-txt-not-important lh-14em m-t-5" style={{marginLeft: '23px'}}>
                                {option.description}
                            </div>
                        }
                    </div>
                )
            })}
        </div>
    )
}
